
const GetPayLoad = (key, defaultValue) =>{

        try{
            const Payload = localStorage.getItem(key);
            return Payload ? JSON.parse(atob(Payload)) : defaultValue;
        }catch(e){
            console.error("Error getting from local storage", e);
            return defaultValue;
        }
};

const SetPayLoad = (key, value) => {
    try{
        localStorage.setItem(key, value);
    }catch(e){
        console.error("Error setting to local storage", e)
    }
    
};

const RemovePayLoad = (key) =>{
    try {
        localStorage.removeItem(key);
      } catch (e) {
        console.error("Error removing from local storage", e);
      }
};

export {GetPayLoad, SetPayLoad, RemovePayLoad};